<template>
    <div class="text-input">
        <label><b>{{label}}</b></label>
        <div class="form-group">

            <select class="form-control" :placeholder="placeholder" :value="value" @change="$emit('input',$event.target.value)" :aria-label="{label}" :disabled="disabled">
                <option v-for="item in list" :key="item.value" :value="item.value">{{item.text}}</option>
            </select>
            <i class="fa fa-chevron-down"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SelectInput",
        props: {
          'label': String,
          'placeholder': String,
          'value': {},
          'list': Array, // of objects
          'disabled': {
              type: Boolean,
              default: false,
          },
        },
    }
</script>

<style lang="scss" scoped>
    .form-group{
        margin-bottom: 0px;
        select {
            -webkit-appearance: none;
            -moz-appearance: none;
            -o-appearance: none;
            /* no standardized syntax available, no ie-friendly solution available */
        }
        select + i.fa {
            float: right;
            margin-top: -26px;
            margin-right: 5px;
            /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
            pointer-events: none;
            background: inherit;
            /* everything after this is just to cover up the original arrow */
            /* (for browsers that don't support the syntax used above) */
            /*background-color: #fff; inherits from form-control*/
            padding-right: 5px;
        }
    }
</style>
